import React, { useEffect } from 'react';
import { Typography, Row, Col, Flex, Space } from 'antd';
import { textStyle } from './styles';
import { ImageTheme } from '../../../components/images';
import { ButtonTheme } from './components/buttons';
import logo from '../../../assets/images/why_logo.jpg';
// import logo from '../../../assets/images/Rizz 500x500-Photoroom.png';
import { useGetPolicyData } from './hook/useGetPolicyData';
import liff from '@line/liff';

export const TermWarranty = () => {
  function onClose() {
    liff.closeWindow();
  }

  const { mutate: fetchPolicyData, data: result } = useGetPolicyData();

  useEffect(() => {
    fetchPolicyData();
  }, []);
  return (
    <div style={{ width: '100vw', height: '100%', overflowY: 'auto' }}>
      <Row>
        <Col span={24}>
          <Space direction="vertical" align="center" style={{ width: '100%' }}>
            <ImageTheme src={logo} style={{ width: 200 }} />
          </Space>
        </Col>
      </Row>
      <Space direction="vertical" size={16} style={{ width: '100%', padding: '0 40px' }}>
        <Row>
          <Col span={24}>
            <Typography.Text
              strong
              style={textStyle.textTitle}
            >{`การรับประกันสินค้าฟิล์มและกระจกกันรอย Why เงื่อนไขการรับประกันสินค้า`}</Typography.Text>
          </Col>
        </Row>
        <Flex vertical justify="center" style={{ width: '100%' }}>
          <Typography.Text style={textStyle.textContent}>
            {result?.item?.policyText}
          </Typography.Text>
        </Flex>

        <Flex justify="center" style={{ width: '100%', marginTop: '15px' }}>
          <ButtonTheme useFor="BACK" title="กลับ" onClick={onClose} />
        </Flex>
      </Space>
    </div>
  );
};
